<div class="layout-wrapper">
  <div id="sidebar" [ngClass]="{'sidebar-visible': isSidebarVisible, 'sidebar-hidden': !isSidebarVisible}">
    <div class="sidebar-inner">
      <img src="assets/images/icon.svg" id="logo" (click)="goToHome()">
      <ng-content></ng-content>
    </div>
  </div>
    <div class="container" style="box-sizing: border-box; position:relative;">
      <div class="row">
        <div class="col">
          <app-header (onSidebarChange)="toggleSidebar($event)"></app-header>
          <div class="main">
            <app-breadcrumb></app-breadcrumb>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
